import config from '@/config/config.json'
import consts from '@/config/consts.json'

export default {
  config,
  consts
}
